import type { UserConfig } from '@commitlint/types'

export const defaultCommitlintConfig: UserConfig = {
  extends: ['@commitlint/config-conventional'],
}
